import { render, staticRenderFns } from "./StudentDashboard.vue?vue&type=template&id=965dac78&scoped=true"
import script from "./StudentDashboard.vue?vue&type=script&lang=ts"
export * from "./StudentDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965dac78",
  null
  
)

export default component.exports